import React from 'react';
import { Video, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const EntrevistasPage = () => {
  const entrevistas = [
    {
      id: 1,
      titulo: 'Entrevista com Especialista em Direito Penal',
      data: '2025-01-04',
      duracao: '35min',
      descricao: 'Discussão sobre as recentes mudanças no código penal brasileiro.'
    },
    {
      id: 2,
      titulo: 'Desafios do Direito Trabalhista Moderno',
      data: '2024-12-28',
      duracao: '40min',
      descricao: 'Análise das transformações nas relações de trabalho contemporâneas.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Entrevistas
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Conversas com especialistas e profissionais do Direito
            </p>
          </div>
        </section>

        {/* Interviews List */}
        <section className="py-16 md:py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-8">
              {entrevistas.map((entrevista) => (
                <Card key={entrevista.id} className="overflow-hidden hover:shadow-xl transition-all duration-300 border-0 hover:scale-105">
                  <CardContent className="p-6 bg-white">
                    <div className="flex flex-col space-y-4">
                      <div className="w-full h-40 bg-[#e2e8f0] rounded-lg flex items-center justify-center">
                        <Video size={48} className="text-[#B49163]" />
                      </div>
                      <h3 className="text-xl font-serif font-semibold text-[#0F172A]">
                        {entrevista.titulo}
                      </h3>
                      <p className="text-gray-600">
                        {entrevista.descricao}
                      </p>
                      <div className="flex items-center gap-4 text-sm text-gray-500">
                        <div className="flex items-center gap-1">
                          <Calendar size={16} />
                          <span>{new Date(entrevista.data).toLocaleDateString('pt-BR')}</span>
                        </div>
                        <span>•</span>
                        <span>{entrevista.duracao}</span>
                      </div>
                      <Button className="w-full bg-[#0F172A] hover:bg-[#1e293b] text-white py-3 rounded-lg transition-colors duration-300">
                        Assistir
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default EntrevistasPage;